import Vue from "vue";
import Vuex from "vuex";

// 挂载Vuex
import Tool from "@/assets/js/common/utils.js";
import { getEnvInitInfo } from "@/assets/js/envConfig";
import Cookies from 'js-cookie'
import axios from "@/assets/js/axiosExtend";
import { userAuth } from '@/assets/js/config';
Vue.use(Vuex);

// 创建VueX对象
const store = new Vuex.Store({
  state: {
    theme: '',
    // 存放的键值对就是所要管理的状态
      isRemoteRecordingFeatureEnabled: false,
  
    session: "",
    isMarker: false,
    websocket: {
      getDownlowd: null,
    },
    userInfo: {}, // 用户基础信息
    config: {}, // 网站基本配置信息
    downloadInfo: null, // 点击session record 等的信息 防止存放到storage里面的数据 被用户清除 导致下载出错
    wafflemenuStatus: false
  },
  mutations: {
    wafflemenuStatus(state, info) {
      state.wafflemenuStatus = info
    },
    setSession(state, session) {
      state.session = session;
    },
    userInfo(state, Info) {
      state.userInfo = Info;
    },
    config(state, info) {
      state.config = info;
    },
    downloadInfo({ commit }, downloadInfo) {
      commit("downloadInfo", downloadInfo);
    },
    setMarker(state, visible) {
      state.isMarker = visible;
    },
    toggleRemoteRecordingFeature(state, property) {
      state.isRemoteRecordingFeatureEnabled = property;
    },
  },
  actions: {
    async commitisWaffleMenu(context, info) {
      context.commit("wafflemenuStatus", info);
    },
    async commitUserInfo(context, info) {
      // 获取基础用户信息
      context.commit("userInfo", info);
    },

    commitMarker(context, info) {
      context.commit("setMarker", info);
    },
    commitConfigInfo(context, info) {
      // 获取基础网站配置
      $.ajax({
        // url: `https://file.tvunetworks.com/filebackend/system/getConfig02?env=tvunetworks`,
        url: `/filebackend/system/getConfig02?env=${getEnvInitInfo().params}`,
        // url: `/filebackend/system/getConfig?env=${getEnvInitInfo().params}`,
        type: "get",
        async: false,
        headers: { Authorization: Tool.getCookie() },
        success(data) {
          // eslint-disable-next-line no-cond-assign,no-constant-condition
          if ((data.errorCode = "0x0")) {
            const result = data.result;
            window.localStorage.setItem("newRcConfig", JSON.stringify(result));
            // window.localStorage.setItem('lastRecordedVersion', currentVersion);
             // result.recordServiceWsUrl =
             //  "file-dev.tvunetworks.com/filebackend-ws/ws/studio";

            context.commit("config", result);
          }
        },
      });
      Vue.prototype.$TVU = {
        http: axios,
        serverName: 'recording service',
        userAuthUrl: userAuth,
        session: Cookies.get('SID')
      }
    },
    commitRemoteRecordingFeature(ctx, info) {
      ctx.commit('toggleRemoteRecordingFeature', info);
    },
  },
  getters: {},
});

export default store;
